<template>
  <div>
    <span v-for="(_, index) in fields" :key="index">
      <label class="code-label">
        <input
          :ref="index"
          @input="event => onChangeNumber(index, event)"
          :id="`input-code-${index}`"
          type="number"
          max="9"
          min="0"
          inputmode="numeric"
          :class="{
            isWrong: codeErrors[index] === 'wrong',
            isLarge: fields.length > 5,
          }"
          @keyup.enter="sendFormNow"
          @paste.prevent
        />
      </label>
    </span>
    <div
      class="error-message"
      :class="{ hasErrors: Object.keys(codeErrors).length }"
    >
      Helaas, dit was niet de juiste code.<br class="em_hide" />
      Zoek nog wat verder voor de cijfers in het rood.
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import leftPad from 'left-pad';

export default {
  props: {
    onSendit: {
      type: Function,
      default: () => {
        // console.log('fromPROOOOPS');
      },
    },
  },
  methods: {
    ...mapMutations(['setCodeAttempt']),
    onChangeNumber(index, event) {
      const value = event.target.value;
      let tried = value ? parseInt(event.target.value, 10).toString() : null;

      if (tried !== null && tried.length > 1) {
        if (this.codeAttempt[index]) {
          const diffMe = tried;
          const diffBy = this.codeAttempt[index];
          const diffed = diffMe.split(diffBy).join('');
          tried = diffed || this.codeAttempt[index];
        }

        tried = tried[0];
      }

      event.target.value = tried;
      this.setCodeAttempt({
        index,
        value: tried,
      });
      if (this.$refs[index + 1] && tried !== null) {
        this.$refs[index + 1][0].focus();
      }
    },
    sendFormNow() {
      this.onSendit();
    },
  },
  mounted() {
    // console.log(this.codeErrors);
    if (this.$refs[0]) {
      this.$nextTick(() => {
        this.$refs[0][0].focus();
      });
    }
  },
  computed: {
    ...mapState(['codeErrors', 'stepData', 'codeAttempt']),
    fields() {
      const num = atob(this.stepData.code) / 3;
      return leftPad(num.toString(), this.stepData.digits, '0').split('');
    },
  },
  name: 'CodeForm',
};
</script>

<style scoped lang="scss">
.code-label {
  input[type='number'] {
    width: 3rem;
    height: 5rem;
    font-size: 2rem;
    border: 1px solid gray;
    margin: 5px;
    padding: 5px;
    border-radius: 1.5rem;
    text-align: center;

    -moz-appearance: textfield;
    -webkit-appearance: textfield;

    &.isWrong {
      border: 2px solid red;
    }

    &.isLarge {
      @media print, screen and (max-width: 450px) {
        width: 2rem;
        height: 3.5rem;
        font-size: 1.2rem;
        margin: 4px;
        padding: 4px;
        border-radius: 1rem;
      }
    }
  }
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
}
.error-message {
  color: red;
  padding: 26px;
  opacity: 0;

  &.hasErrors {
    opacity: 1;
  }
}
</style>
